exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".fRgwM30-cSjMH6ByxRVEE{background:#f4b418;max-height:500px;display:grid;grid-template-rows:5fr 18fr 1fr;grid-template-columns:1fr 6fr 1fr}._1c12p9zyXwsynrBWF7GQF1{grid-row:1/2;grid-column:1/-1;display:flex;justify-content:center;align-items:center;font-size:1.125rem;font-weight:bold;color:#143859}.obxbf6PNzp6mgTrUQ48Pb{grid-row:2/3;grid-column:2/3}\n", ""]);
// Exports
exports.locals = {
	"main": "fRgwM30-cSjMH6ByxRVEE",
	"header": "_1c12p9zyXwsynrBWF7GQF1",
	"contactForm": "obxbf6PNzp6mgTrUQ48Pb ui form"
};